<template lang="pug">
	.analytics-opt-in
		.timeline-message(v-if="showMessage")
			span.timeline-icon
			.message-wrapper
				.left-column

					p.action-icon.has-text-centered
						img(src="@/assets/img/icons/cookie.svg", width="32", height="32")
				.right-column
					article.message-content
						h4 Statistik-Cookies
						p Wir wollen unseren Live-Ticker noch besser machen. Darum brauchen wir Euch und würden gerne Cookies nutzen, um die Spieltagsberichte noch attraktiver für Euch zu gestalten.
						div(v-if="showDetails")
							p Wir nutzen Google Analytics, um statistische Daten zu erfassen, wie der Besucher die Webseite nutzt.
							a.link.has-text-secondary(href="https://www.holstein-kiel.de/datenschutz/" target="_blank") Datenschutzerklärung
							br
							br
							p
								| #[strong Cookie-Namen:]#[br]
								| #[code _ga, _gat, _gid], Cookie-Laufzeit: 2 Jahre, Anbieter: Google LLC#[br]
								| #[code cookie_opt_in], Cookie-Laufzeit: 2 Jahre, Anbieter: Kieler Sportvereinigung Holstein von 1900 e.V.
							br
						p #[a(@click="showDetails = !showDetails") {{ showDetails ? 'Weniger anzeigen' : 'Mehr erfahren' }}..]
						.buttons
							button.button.is-text(type="is-secondary" @click="onDeclineButtonClicked") Ablehnen
							button.button.is-primary(type="is-primary" @click="onAcceptButtonClicked") Akzeptieren
</template>
<script>

const COOKIE_KEY = 'cookie_opt_in'
const ACCEPTED_VALUE = 'accepted'
const DECLINED_VALUE = 'declined'
const TWO_YEARS = 60 * 60 * 24 * 365 * 2
export default {
	data () {
		return {
			showDetails: false,
			showMessage: false
		}
	},
	beforeMount () {
		// Don't setup at all if no gtag variable is provided
		if (process.env.VUE_APP_GTAG_ID == null) {
			this.showMessage = false
			return
		}

		// If no consent given or invalid consent given, display message
		const value = this.$cookies.get(COOKIE_KEY)
		if (value == null || (value !== ACCEPTED_VALUE && value !== DECLINED_VALUE)) {
			this.$cookies.remove(COOKIE_KEY)
			this.showMessage = true
			return
		}

		// Consent already given, perform setup
		if (value === ACCEPTED_VALUE) {
			this.updateCookieTracking()
		}
		// Anonymous tracking is the default behavior
	},
	methods: {
		onDeclineButtonClicked () {
			this.$cookies.set(COOKIE_KEY, DECLINED_VALUE, TWO_YEARS)

			// Remove all google analytics cookies
			this.$cookies
				.keys()
				.filter(k => k.startsWith('_ga'))
				.map(k => this.$cookies.remove(k))

			// this.setupAnonymousTracking() // Anonymous tracking is the default
			this.showMessage = false
			if (gtag == null) {
				console.warn('No global gtag')
				return
			}
			gtag('event', 'analytics_optout', {
				'event_category': 'engagement'
			})
		},
		onAcceptButtonClicked () {
			this.$cookies.set(COOKIE_KEY, ACCEPTED_VALUE, TWO_YEARS)
			this.updateCookieTracking()
			this.showMessage = false
			if (gtag == null) {
				console.warn('No global gtag')
				return
			}
			gtag('event', 'analytics_optin', {
				'event_category': 'engagement'
			})
		},
		updateCookieTracking () {
			if (gtag == null) {
				console.warn('No global gtag')
				return
			}
			gtag('consent', 'update', {
				analytics_storage: 'granted'
			})
			gtag('set', 'user_properties', {
				tracking: 'cookie'
			})
		}
	}
}
</script>

<style lang="scss" scoped>
	@import "@/assets/scss/bulma-variables.scss";
	$timeline: #B61615;
	.analytics-opt-in {
		margin-bottom: 2em;
	}
	.timeline-message {
		background: white;
		border: 1px solid white;
		overflow: hidden;
		position: relative;
		font-family: 'Bunday Sans', sans-serif;

		.buttons.actions {
			position: absolute;
			top: 1em;
			right: 1em;

			z-index: 10;
		}

		.timeline-icon {
			width: 16px;
			height: 16px;
			border-radius: 8px;
			background: $timeline;
			z-index: 2;
			position: absolute;
			top: 17px;
			left: 12%;
			margin-left: -8px;
		}
		.message-wrapper {
			display: flex;
			width: 100%;
			.left-column {
				flex-shrink: 0;
				width: 12%;
				padding: 10px;
			}
			.right-column {
				flex-grow: 1;
				overflow: hidden;
				padding: 10px 20px;
			}
		}

		.message-content {
			padding-right: 1em;
			padding-left: 1em;
			min-height: 24px;
			.content {
				margin-bottom: 0;

				// iFrame min height
				::v-deep iframe {
					min-height: 315px;
				}
			}
		}

		@media screen and (max-width: 768px) {
			.timeline-icon {
				width: 32px;
				height: 32px;
				margin-left: -16px;
				border-radius: 16px;
				background: white;
				left: 20px;
			}

			.action-icon {
				position: absolute;
				left: 20px;
				z-index: 99;
				width: 24px;
				height: 24px;
				margin-left: -12px;
				top: 21px;
				z-index: 3;
				img {
					width: 24px;
					height: 24px;
				}
			}

			&.has-no-icon .timeline-icon::before {
				position: absolute;
				content: '';
				background: $timeline;
				width: 18px;
				height: 18px;
				top: 7px;
				left: 7px;
				border-radius: 9px;
				z-index: 3;
			}
			.message-wrapper {
				.left-column {
					width: 36px;
				}
				.right-column {
					padding: 10px 5px;
					padding-left: 0;
				}
			}
			.message-content {
				padding-left: 5px;
				padding-right: 5px;
				padding-top: 13px;
			}

			&.has-time {
				.time {
					position: absolute;
					left: 41px;
					top: 18px;
				}
				.message-content {
					padding-top: 50px;
				}
			}
		}
	}
</style>
